import { forwardRef } from "react";
import { useVisualFormContext } from "../../../contexts/VisualFormContext";
import { useCardLayoutContext } from "../../../contexts/CardLayoutContext";


export const PlaceholderTile = forwardRef(({ item, ...rest }, fRef) => {

    const { visualObject } = useVisualFormContext();

    const {
        isBoxColliding,
        handlePlaceholderClick,
        handlePlaceholderMouseUp,
        handlePlaceholderMouseDown,
        handlePlaceholderMouseOver
    } = useCardLayoutContext();

    const visualObjectCoordinates = visualObject ? {
        x: visualObject.PositionX,
        y: visualObject.PositionY,
        w: visualObject.Width,
        h: visualObject.Height
    } : null;

    const activeClass = isBoxColliding(item, visualObjectCoordinates) ? "active" : "";
    const collisionClass = isBoxColliding(item) ? "collision" : "";

    return (
        <div
            ref={fRef}
            {...rest}
            key={item.i}
            className={`placeholder-cell ${activeClass} ${collisionClass}`}
            onClick={() => handlePlaceholderClick(item)}
            onMouseUp={() => handlePlaceholderMouseUp(item)}
            onMouseDown={() => handlePlaceholderMouseDown(item)}
            onMouseOver={() => handlePlaceholderMouseOver(item)}
        />
    );
});